import axios from 'axios';
import TokenManager from '../services/TokenManager';
import { requiredEnv } from '../lib/env';

const api = axios.create({
  baseURL: requiredEnv('VITE_API_URL'),
  headers: {
    'Content-Type': 'application/json',
  },
});

const publicApi = axios.create({
  baseURL: requiredEnv('VITE_API_URL'),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Configura interceptors usando o TokenManager
TokenManager.setupAxiosInterceptors(api, true); // API privada com ambos os tokens
TokenManager.setupAxiosInterceptors(publicApi, false); // API pública só com Sensedia

export { publicApi };
export default api;
